import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import WoffEmbeddedMixin from 'mixins/WoffEmbeddedMixin';

const WoffEmbeddedText = createReactClass({
  propTypes: {
    text: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
      PropTypes.arrayOf(PropTypes.string),
    ]),
    className: PropTypes.string,
  },

  mixins: [WoffEmbeddedMixin, PureRenderMixin],

  getStyles() {
    return {
      fontFamily: `'${this._name}'`,
    };
  },

  renderText() {
    return <span className={this.props.className} style={this.getStyles()}>{this.props.text}</span>;
  },

  renderChildren() {
    return <div className={this.props.className} style={this.getStyles()}>{this.props.children}</div>;
  },

  render() {
    let value = null;

    if (this.props.children) {
      value = this.renderChildren();
    }

    if (this.props.text) {
      value = this.renderText();
    }

    return value;
  },
});

export default WoffEmbeddedText;



// WEBPACK FOOTER //
// ./app/javascript/components/WoffEmbeddedText.js